import React, { createContext, useContext, useState, useEffect } from 'react';

const CartCtx = createContext(null);
const KEY = 'trucrunch_cart';

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (err) {
      console.warn('[cart] failed to parse saved cart', err);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product) => {
    setItems((cur) => {
      const existing = cur.find((i) => i.product_id === product.id);
      if (existing) return cur.map((i) => i.product_id === product.id ? { ...i, qty: i.qty + 1 } : i);
      return [...cur, { product_id: product.id, title: product.title, price: product.price, image: product.image, color: product.color, qty: 1 }];
    });
    setOpen(true);
  };

  const remove = (product_id) => setItems((cur) => cur.filter((i) => i.product_id !== product_id));
  const setQty = (product_id, qty) => setItems((cur) => qty <= 0 ? cur.filter((i) => i.product_id !== product_id) : cur.map((i) => i.product_id === product_id ? { ...i, qty } : i));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const shipping = subtotal === 0 ? 0 : (subtotal >= 499 ? 0 : 49);
  const total = subtotal + shipping;
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, subtotal, shipping, total, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartCtx);
  if (!ctx) throw new Error('useCart must be inside CartProvider');
  return ctx;
};
